<template lang="html">
    <div class="panel panel-default">
        <div class="panel-heading">Campaigns</div>
        <div class="panel-body">
            <table class="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Code</th>
                        <th>Save</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(campaign, idx) in platform.campaigns" :key="campaign.campaign_id">
                        <td>
                            <input class="form-control" type="text" v-model="campaign.name">
                        </td>
                        <td>
                            <input class="form-control" type="text" v-model="campaign.campaign_id" disabled>
                        </td>
                        <td>
                            <button type="button" :class="['btn', savedState(idx) ? 'btn-success' : 'btn-default']" @click="updateCampaign(campaign, idx)">
                                <i class="fa fa-save"></i>
                            </button>
                        </td>
                        <td>
                            <button type="button" class="btn btn-default" @click="deleteCampaign(campaign.campaign_id)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input class="form-control" type="text" v-model="newCampaign.name" placeholder="Campaign Name">
                        </td>
                        <td>
                            <input class="form-control" type="text" v-model="newCampaign.campaign_id" placeholder="Campaign ID/Code">
                        </td>
                        <td>
                            <button type="button" class="btn btn-default" @click="addCampaign">
                                <i class="fa fa-plus"></i>
                            </button>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            newCampaign: {
                name: '',
                campaign_id: '',
                status: 'ENABLED',
            },
            saved: []
        }
    },

    computed: {
        ...mapGetters('client',{
            'platform': 'activeCallPlatform',
            'isAdmin': 'isAdmin',
            'client': 'activeClient',
        }),
    },

    methods: {
        addCampaign() {
            this.$store.dispatch('client/addCallTrackingCampaign', {
                campaign: this.newCampaign,
                platform: this.platform
            }).then(() => {
                this.platform.campaigns.push({
                    'name': this.newCampaign.name,
                    'campaign_id': this.newCampaign.campaign_id
                });
                this.newCampaign.name = '';
                this.newCampaign.campaign_id = '';
            })
        },

        deleteCampaign(id) {
            this.$store.dispatch('client/deleteCallTrackingCampaign', {
                campaign_id: id,
                platform: this.platform
            }).then(() => {
                this.platform.campaigns = this.platform.campaigns.filter(c => c.campaign_id != id);
            });
        },

        updateCampaign(campaign, idx) {
            this.$store.dispatch('client/updateCallTrackingCampaign', {
                id: campaign.campaign_id,
                campaign: campaign,
                platform: this.platform
            }).then(() => {
                this.saved.push(idx);
                setTimeout(() => this.saved.splice(this.saved.indexOf(idx), 1), 500);
            });
        },

        savedState(idx) {
            return this.saved.indexOf(idx) != -1;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/CallTrackingCampaignList.vue